module.exports = __webpack_public_path__ + "static/bahnreisen-1f0a0cc9bf42001830f0d02e56e2f73b.svg";